var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showExpanded)?_c('img',{staticClass:"bg-white expand-step-icon",attrs:{"src":require("../../../public/icons/icon-minus.svg")}}):_c('img',{staticClass:"bg-white expand-step-icon",attrs:{"src":require("../../../public/icons/icon-plus.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }